import { bootcamps } from '../utility'
import { TfiTime } from 'react-icons/tfi'
function BootcampSection() {
  return (
    <div className=" text-txColor dark:text-neutral-100 justify-center  py-20  lg:mt-10 z-10   px-4 sm:px-10 lg:px-20 grid sm:grid-cols-2 lg:grid-cols-3 gap-10 mt-5 w-full">
      {bootcamps.map((boot) => {
        return (
          <div key={boot.id} className="bg-bgPinkSection p-4 rounded-lg">
            <p className="text-lg  font-semibold">{boot.name}</p>
            <p className="mt-2 text-white">{boot.organization}</p>

            <p className="mt-4 text-base">{boot.description}</p>
            <p className="flex text-sm mt-4">
              Stack: <div> </div>
              {boot.stack.map((st) => {
                return (
                  <p className="flex text-sm  p-0 w-fit mr-2" key={st.id}>
                    {st.name}
                  </p>
                )
              })}
            </p>
            <p className="flex items-center mt-4">
              <TfiTime className="mr-2" />
              <p className="text-sm"> {boot.duration}</p>
            </p>
          </div>
        )
      })}
    </div>
  )
}

export default BootcampSection
